module.exports = __webpack_public_path__ + "store/img/shop-tags-personalize-qr.8e14fe19.png";